import { render, staticRenderFns } from "./SupportAvatar.vue?vue&type=template&id=722d8628&scoped=true&"
import script from "./SupportAvatar.vue?vue&type=script&lang=js&"
export * from "./SupportAvatar.vue?vue&type=script&lang=js&"
import style0 from "./SupportAvatar.vue?vue&type=style&index=0&id=722d8628&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722d8628",
  null
  
)

export default component.exports